export default {
  props: ['open']
}



// WEBPACK FOOTER //
// ./src/component/landing/popupinfo/popupinfo.js